import styles from './CartScreen.module.scss';
import { CartContext } from '../../Contexts/CartContext';
import { CartItem } from './CartScreen';
import { useContext } from 'react';

const CartTable = () => {
    const cartContext = useContext(CartContext);
    return (
        <table className={styles.table}>
            <thead>
                <tr>
                    <th></th>
                    <th>Product</th>
                    <th>Quantity</th>
                    <th>Unit price</th>
                    <th>Total price</th>
                </tr>
            </thead>
            <tbody>
                {
                    cartContext.cartItems.map((item, index) => {
                        return <CartItem key={index} item={item} />
                    })
                }
            </tbody>
        </table>
    );
};

export default CartTable;